import React from 'react'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import clsx from 'clsx'
import editImg from '../../../assets/web/edit.png'
import forbidImg from '../../../assets/web/forbid.png'
import lockImg from '../../../assets/web/lock.png'
import rightImg from '../../../assets/web/right.png'
import wrongImg from '../../../assets/web/wrong.png'
import deleteImg from '../../../assets/web/delete.png'
import activeImg from '../../../assets/web/open.png'
import Photo from '../../photo'

const Item = styled.div`
  border-bottom: 1px solid #dbdfea;
  // .active{
  //     .time {
  //   ${tw`font-medium`}
  // }
  .delete {
    font-size: 0.875rem;
    color: #d32929;
  }
  .edit {
    font-size: 0.875rem;
    color: #2d3748;
  }
  .quit {
    font-size: 0.875rem;
    color: #1c3faa;
  }
  &:hover {
    background: #f5f6fa;
  }
  .item-name {
    font-weight: 600;
    color: #364a63;
  }
  ${tw`transition duration-200 ease-in-out transform cursor-pointer`}
`

const userStatus = {
  '-1': '未激活',
  0: '待审批',
  1: '正常',
  2: '已离职',
  true: '已交接',
  false: '已禁用',
}

const statuscolor = {
  '-1': 'text-secondary-900',
  0: 'text-orange-900',
  1: 'text-primary-900',
  2: 'text-orange-900',
  true: 'text-primary-900',
  false: 'text-danger-900',
}

const statusbgcolor = {
  '-1': 'bg-dark-50',
  0: 'bg-orange-50',
  1: 'bg-primary-50',
  2: 'bg-orange-50',
  true: 'bg-primary-50',
  false: 'bg-danger-50',
}

const statuspointColor = {
  '-1': 'bg-secondary-900',
  0: 'bg-orange-900',
  1: 'bg-blue-900',
  2: 'bg-blue-900',
  true: 'bg-blue-900',
  false: 'bg-danger-900',
}
const optColor = ['#395ec1', '#ffc539', '#ff7b54', '#8a97a5', '#f04c38']

const FAIcon = function (icon) {
  return <img alt="" className="w-3.5 h-3.5" src={icon} />
}

const renderName = function (v) {
  return v && v.length > 5 ? v.substring(0, 5) + '...' : v
}
const TableItem = function ({ row, style, onOperateUser, isAdmin = false }) {
  const currentUser = row.original || {}

  const onClickOperateUser = (opt) => {
    return () => {
      if (onOperateUser) {
        onOperateUser(currentUser, opt)
      }
    }
  }
  const renderOperate = (obj) => {
    // 待审批
    if (obj.status === '0') {
      return (
        <div className="flex justify-center items-center text-sm">
          <div
            className="edit flex items-center mr-6"
            title="通过"
            onClick={onClickOperateUser('pass')}
          >
            {FAIcon(rightImg, optColor[0])}
          </div>
          <div
            className="edit flex items-center mr-6"
            title="拒绝"
            onClick={onClickOperateUser('refuse')}
          >
            {FAIcon(wrongImg, optColor[2])}
          </div>
        </div>
      )
    }
    // 未激活
    if (obj.status === '-1') {
      return (
        <div className="flex justify-center items-center text-sm">
          <div
            className="edit flex items-center mr-6"
            title="编辑"
            onClick={onClickOperateUser('edit')}
          >
            {FAIcon(editImg, optColor[0])}
          </div>
        </div>
      )
    }
    if (obj.status === '2' && !obj.handled) {
      return (
        <div className="flex justify-center items-center text-sm">
          <div
            className="quit flex items-center mr-6"
            title="交接"
            onClick={onClickOperateUser('quit')}
          >
            {FAIcon(optColor[2])}
          </div>
        </div>
      )
    }
    // 正常
    return (
      <div className="flex justify-center items-center text-sm">
        {obj.active && (
          <div
            className="edit flex items-center mr-6"
            title="编辑"
            onClick={onClickOperateUser('edit')}
          >
            {FAIcon(editImg, optColor[0])}
          </div>
        )}
        <div
          className="flex items-center mr-6"
          title={obj.active ? '禁用' : '启用'}
          onClick={onClickOperateUser('enable')}
        >
          {FAIcon(
            obj.active ? forbidImg : activeImg,
            obj.active ? optColor[4] : optColor[0]
          )}
        </div>
        {/* 确实需要判断用户类型 */}
        {isAdmin && obj.active && (
          <div
            className="delete flex items-center mr-6"
            title="修改密码"
            onClick={onClickOperateUser('pwd')}
          >
            {FAIcon(lockImg, optColor[3])}
          </div>
        )}
        {!obj.active && (
          <div
            className="delete flex items-center"
            title="移除"
            onClick={onClickOperateUser('delete')}
          >
            {FAIcon(deleteImg, statuscolor.false)}
          </div>
        )}
      </div>
    )
  }

  const renderInfo = (cell, column) => {
    const { original } = row
    const { name = '', status, active, id, org, username } = original
    if (column.id === 'name') {
      return (
        <div className="w-full flex flex-row items-center">
          <Photo src={original.photo} name={name} userId={id} />
          <span title={name} className="ml-2">
            {renderName(name)}
          </span>
        </div>
      )
    }
    if (column.id === 'org') {
      return (
        <span title={org} className="text-ellipsis">
          {renderName(org)}
        </span>
      )
    }
    if (column.id === 'username') {
      return (
        <span
          className="whitespace-no-wrap overflow-hidden"
          style={{ textOverflow: 'ellipsis', width: '80%' }}
        >
          {username}
        </span>
      )
    }
    if (column.id === 'status') {
      return (
        <div
          className={clsx(
            statuscolor[active ? status : false],
            statusbgcolor[active ? status : false],
            'flex items-center justify-center rounded-2xl'
          )}
          style={{
            padding: '0.1125rem 0.625rem',
          }}
        >
          <div
            className={clsx(
              statuspointColor[active ? status : false],
              'rounded-full mr-1.5'
            )}
            style={{
              width: '0.4rem',
              height: '0.4rem',
            }}
          />
          <span>{userStatus[active ? status : false]}</span>
        </div>
      )
    }
    if (column.id === 'operate') {
      return renderOperate(original)
    }
    return cell.render('Cell')
  }

  return (
    <Item
      {...row.getRowProps({ style })}
      className="flex pl-4"
      key={row.original.id}
    >
      {row.cells.map((cell) => {
        const { column } = cell
        return (
          <div
            {...cell.getCellProps()}
            key={column.id}
            className={clsx([
              {
                'w-32 lg:w-1/6': column.id !== 'selection',
                'w-10': column.id === 'selection',
                'item-name': column.id === 'name',
              },
              'flex items-center p-2',
            ])}
          >
            {renderInfo(cell, column)}
          </div>
        )
      })}
    </Item>
  )
}
export default TableItem
